<template>
	<div class="commonModalBlo">
		<div class="commonModal modal">
			<div class="commonTitle">
				{{tipsData[index].tipsTitle}}提醒
			</div>

			<div class="commonCon">
				<div class="tips color_FFF">
					{{tipsData[index].text}}
				</div>

				<div class="displayF8Center rowGap8 flexWrap marginTB16">
					<div v-if="propsObj.fileName" class="fileMessSty">
						<div class="displayF12Center">
							<img :src="isImageMethods(propsObj.fileName) ? initThemeImg(theme, 'icon_tips_pic@2x') : getTipsFileIcon(theme, propsObj.fileName)"
								alt="" class="flexShrink0 imgWH32" />

							<div class="maxWidthSty">
								<div class="marginBottom10">
									<elTooltipCommon :data="propsObj.fileName || '-'" :dataRef="'fileName' + i">
									</elTooltipCommon>
								</div>

								<div>
									上传情况：<span
										class="cursorColor">{{propsObj.progress && propsObj.progress == 100 ? '上传完成' : '上传中'}}</span>
								</div>
							</div>
						</div>
					</div>

					<!-- 最多两个上传附件情况 目前只有在说明文档编辑页会出现 富文本+产品说明图 以下为产品说明图部分数据展示 -->
					<div v-if="propsObj.fileNameSec" class="fileMessSty">
						<div class="displayF12Center">
							<img :src="isImageMethods(propsObj.fileNameSec) ? initThemeImg(theme, 'icon_tips_pic@2x') : getTipsFileIcon(theme, propsObj.fileNameSec)"
								alt="" class="flexShrink0 imgWH32" />

							<div class="maxWidthSty">
								<div class="marginBottom10">
									<elTooltipCommon :data="propsObj.fileNameSec || '-'" :dataRef="'fileNameSec' + i">
									</elTooltipCommon>
								</div>

								<div>
									上传情况：<span
										class="cursorColor">{{propsObj.progressSec && propsObj.progressSec == 100 ? '上传完成' : '上传中'}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="tips">
					提示：弹窗内等待附件上传完成后点击确认，确认后附件可正常保存。
				</div>
			</div>

			<div class="buttonBlo buttonBloP">
				<el-button @click="submitHandle()" type="primary" :loading="loading">
					{{getSureText('确定')}}
				</el-button>

				<el-button @click="cancel()">{{getCancelText()}}</el-button>

				<!-- 20260302 注释原按钮逻辑 -->
				<!-- <div class="left" @click="submitHandle()">
					{{getSureText('确定')}}
				</div>
				<div class="rig" @click="cancel()">{{getCancelText()}}</div> -->
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		getSureText,
		initThemeImg,
		getCancelText,
		isImageMethods,
		setMessageQueue,
		getTipsFileIcon
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user.js'
	import {
		watch
	} from 'vue'

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		propsObj: {
			type: Object,
			default: () => {}
		}
	})

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})
	const tipsTitle = computed(() => {
		return props.propsObj.tipsTitle
	})

	const index = ref(0)
	const progress = ref(0)
	const tipsData = ref([{
		tipsTitle: '返回',
		text: '检测到当前附件上传未完成，离开后上传将中断，附件可能丢失，是否确认离开？'
	}, {
		tipsTitle: tipsTitle.value, // 根据实际按钮来显示文案
		text: '检测到当前附件上传未完成，' + tipsTitle.value + '离开后上传将中断，附件可能丢失，是否确认' + tipsTitle.value + '？'
	}])
	const loading = ref(false)

	// 监听
	watch(() => props.propsObj, val => {
		index.value = val.index
		progress.value = val.progress

		// 弹窗获取角度 保证快捷键正常使用
		if (val.progress === 100) {
			setTimeout(() => {
				document.activeElement.focus()

				console.log(document.activeElement, 'document.activeElementdocument.activeElement')
			})
		}

		console.log(val, 'val')

		if (val.loadingReset) {
			loading.value = false
		}

		// console.log(val, loading.value, 'val propsObj watch')
	}, {
		deep: true,
		immediate: true
	})

	function cancel() {
		proxy.$emit('cancelHandle')
	}

	// 确定
	function submitHandle() {
		proxy.$emit('sureHandle')
		// 弹窗 可直接禁用按钮
		loading.value = true
	}

	// 点击回车键
	function keyDown(e) {
		let shortcutModelArr = userConfigData.value.shortcutModelArr
		console.log(e, 'e keyDown document.activeElement', document.activeElement)

		if (e.key === 'Escape') {
			if (shortcutModelArr.includes(3)) {
				// esc 关闭弹窗
				cancel()
			}
		}

		// shift+enter => 20260311 修改为enter快捷键方式 e.shiftKey && 
		if (e.key === 'Enter') {
			if (shortcutModelArr.includes(1)) {
				e.preventDefault();
				// 直接调用确定
				submitHandle()
				e.stopPropagation();
			}
		}
	}

	onMounted(() => {
		// 当前是弹窗
		useUserStore().isModal = true

		// 绑定监听事件
		window.addEventListener('keydown', keyDown, true)
	})

	onUnmounted(() => {
		useUserStore().isModal = false

		window.removeEventListener('keydown', keyDown, true)
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.commonModalBlo .modal .commonCon .color_FFF {
		@include color('color_FFF');
	}

	.fileMessSty {
		min-width: 216px;
		max-width: 100%;
		width: fit-content;
		font-size: 12px;
		line-height: 18px;
		box-sizing: border-box;
		;
		padding: 12px 16px;
		border-radius: 2px;
		@include color('color_FFF');
		@include background('select_back');
	}

	.maxWidthSty {
		max-width: calc(100% - 44px);
	}
</style>